import React, { useState } from 'react';
import {
    GoogleMap,
    withScriptjs,
    withGoogleMap,
    Marker
} from 'react-google-maps';

const CandidateMap = withScriptjs(withGoogleMap((props) => {
    const icon1 = {
        url: "http://maps.google.com/mapfiles/ms/icons/red.png",
        anchor: new window.google.maps.Point(5, 5),
        scaledSize: new window.google.maps.Size(37, 37)
    };

    const icon2 = {
        url: "http://maps.google.com/mapfiles/ms/icons/blue.png",
        anchor: new window.google.maps.Point(5, 5),
        scaledSize: new window.google.maps.Size(32, 32)
    };
    //console.log("From Map popup", props);
    const [lat, setLat] = useState(parseFloat(props.lat))
    const [lng, setLng] = useState(parseFloat(props.lng))
    return (
        <GoogleMap
            defaultZoom={10}
            defaultCenter={{ lat, lng }}
        >
            <Marker
                icon={icon1}
                position={{ lat, lng }}
            />
            {props.locationMapCandidateList.map((item, index) => (
                <Marker
                    key={index}
                    icon={icon2}
                    position={{
                        lat: parseFloat(item.candidateLatitude),
                        lng: parseFloat(item.candidateLongitude)
                    }}
                />
            ))}
        </GoogleMap>
    )
}))

export default CandidateMap;